import {
  // Currencies,
  Notifications,
} from '@orbital/games-frontend-library'
import { Currencies } from '../../../helpers/currency/getCurrencySymbol'
import { checkAutoConfigs } from './autoplay/checkConfigs'
import { increaseBet } from './autoplay/helperIncreaseStake'
import floorFigure from './floorFigure'

export const handleSaveConfigHelper = (
  autoConfig: any,
  autoConfigOne: any,
  autoConfigTwo: any,
  autoConfigThree: any,
  handleAutoConfigCTX: any,
  sendConfigs: any,
  setActive: any,
  active: any,
  handleStake: any,
  handleRollUnderValue: any,
  handleSliderValue: any,
  settings: any,
) => {
  handleStake(autoConfig.stake)
  handleRollUnderValue(autoConfig.rollUnder)
  handleSliderValue(autoConfig.rollNumber)
  if (autoConfigOne.isSaved === '0') {
    handleAutoConfigCTX(autoConfig, 'autoConfigOne')
    setActive(1)
    sendConfigs(autoConfig, autoConfigTwo, autoConfigThree, settings)
  } else if (autoConfigOne.isSaved === '1' && autoConfigTwo.isSaved === '0') {
    handleAutoConfigCTX(autoConfig, 'autoConfigTwo')
    setActive(2)
    sendConfigs(autoConfigOne, autoConfig, autoConfigThree, settings)
  } else if (autoConfigThree.isSaved === '0') {
    handleAutoConfigCTX(autoConfig, 'autoConfigThree')
    setActive(3)
    sendConfigs(autoConfigOne, autoConfigTwo, autoConfig, settings)
  } else {
    if (active === 1) {
      sendConfigs(autoConfig, autoConfigTwo, autoConfigThree, settings)
    } else if (active === 2) {
      sendConfigs(autoConfigOne, autoConfig, autoConfigThree, settings)
    } else {
      sendConfigs(autoConfigOne, autoConfigTwo, autoConfig, settings)
    }
    handleAutoConfigCTX(
      autoConfig,
      active === 3
        ? 'autoConfigThree'
        : active === 2
        ? 'autoConfigTwo'
        : 'autoConfigOne',
    )
  }
}

export const handleAutoHelper = (
  stake: any,
  baseStake: any,
  sliderValue: any,
  rollUnder: any,
  finalBalance: any,
  handleNotification: any,
  resetAuto: any,
  lastBetId: any,
  setlastBetId: any,
  bet: any,
  myTimeout: any,
  betCount: any,
  autoRollNumber: any,
  stopOnLoss: any,
  stopOnProfit: any,
  ggr: any,
  autoMaxStake: any,
  setStep: any,
  diceSocketMessages: any,
  onLoss: any,
  onLossPercent: any,
  onWin: any,
  onWinPercent: any,
  setggr: any,
  handleStake: any,
  rake: any,
  pouseauto: any,
  setpouseauto: any,
  maxbet: any,
  currency: any,
  setbetCount: any,
) => {
  if (Number(stake) > Number(finalBalance)) {
    handleNotification(Notifications.notEnoughBalance)
    resetAuto()
  } else {
    setggr(Number(ggr) + bet.profit)
    if (lastBetId !== bet.bet_id || (lastBetId === '' && bet.bet_id === '')) {
      if (stake <= maxbet) {
        setlastBetId(bet.bet_id)
        setbetCount(betCount + 1)
        myTimeout.current = setTimeout(function () {
          if (
            checkAutoConfigs(
              betCount,
              autoRollNumber,
              stopOnLoss,
              stopOnProfit,
              ggr,
              stake,
              autoMaxStake,
              setStep,
            )
          ) {
            diceSocketMessages.placeBet(
              increaseBet(
                pouseauto,
                bet.profit,
                stake,
                baseStake,
                onLoss,
                onLossPercent,
                onWin,
                onWinPercent,
                2,
                handleStake,
              ),
              sliderValue,
              rollUnder,
              rake,
            )
            setpouseauto(false)
          }
        }, 300)
      } else {
        handleNotification(
          Notifications.maxStake +
            floorFigure(maxbet.toString(), 2) +
            Currencies[currency].symbol,
        )
      }
    } else {
      resetAuto()
    }
  }
}
